import React from 'react';
import { Alert } from '@planne-software/uni';
import { IconInfoCircle } from '@planne-software/uni/icons';

import { useAdderError } from '@src/domains/products/hooks/useAdderError';

const BookingError = () => {
  const errorMessages = useAdderError();

  if (!errorMessages.length) {
    return null;
  }

  return (
    <Alert
      severity='error'
      title={errorMessages.join('. ')}
      startIcon={<IconInfoCircle size={24} style={{ flexShrink: 0 }} />}
    />
  );
};

export default BookingError;
